import { collection, getDocs, doc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { COLLECTIONS } from './schema';
import { FREE_PLAN } from './plans';

export const initializeDatabase = async () => {
  try {
    // Initialize collections
    const collections = [
      COLLECTIONS.USERS,
      COLLECTIONS.ORDERS,
      COLLECTIONS.PACKAGES
    ];

    // Create collections if they don't exist
    for (const collectionName of collections) {
      const collectionRef = collection(db, collectionName);
      await getDocs(collectionRef);
    }

    // Initialize default packages if they don't exist
    const packagesRef = collection(db, COLLECTIONS.PACKAGES);
    const defaultPackages = [
      {
        id: 'holiday-cheer',
        name: 'Holiday Cheer Package',
        price: 15,
        videoCount: 1
      },
      {
        id: 'family',
        name: 'Family Package',
        price: 49,
        videoCount: 6
      },
      {
        id: 'santas-sleigh',
        name: "Santa's Sleigh Package",
        price: 150,
        videoCount: 15
      }
    ];

    for (const pkg of defaultPackages) {
      const docRef = doc(packagesRef, pkg.id);
      const docSnap = await getDocs(docRef);
      if (!docSnap.exists) {
        await setDoc(docRef, pkg);
      }
    }

    console.log('✅ Database initialized successfully');
  } catch (error) {
    console.error('❌ Error initializing database:', error);
  }
};

export const assignDefaultPlanToUsers = async () => {
  try {
    const usersRef = collection(db, COLLECTIONS.USERS);
    const usersSnapshot = await getDocs(usersRef);

    const batch = [];
    for (const userDoc of usersSnapshot.docs) {
      const userData = userDoc.data();
      if (!userData.plan) {
        batch.push(
          updateDoc(userDoc.ref, {
            plan: {
              ...FREE_PLAN,
              purchasedAt: new Date()
            }
          })
        );
      }
    }

    if (batch.length > 0) {
      await Promise.all(batch);
      console.log('✅ Default plans assigned successfully');
    }
  } catch (error) {
    console.error('❌ Error assigning default plans:', error);
    throw error;
  }
};